// extracted by mini-css-extract-plugin
module.exports = {"container":"TopSection_container__3qM4Y","imagesWrapper":"TopSection_imagesWrapper__1FDMq","logoWrapper":"TopSection_logoWrapper__1SL01"};